import React, {Suspense} from 'react'
import taskFooterTeamAssigneeMenuQuery, {

} from '~/__generated__/TaskFooterTeamAssigneeMenuQuery.graphql'
import MockFieldList from '../../../components/MockFieldList'

import useQueryLoaderNow from '../../../hooks/useQueryLoaderNow'

import TaskFooterTeamAssigneeMenu from './OutcomeCardAssignMenu/TaskFooterTeamAssigneeMenu'







const TaskFooterTeamAssigneeMenuRoot = (props) => {
  const {menuProps, task, useTaskChild} = props
  useTaskChild('teamAssignee')
  const queryRef = useQueryLoaderNow(
    taskFooterTeamAssigneeMenuQuery,
    {}
  )
  return (
    React.createElement(Suspense, { fallback: React.createElement(MockFieldList, null ),}
      , queryRef && (
        React.createElement(TaskFooterTeamAssigneeMenu, { queryRef: queryRef, menuProps: menuProps, task: task,} )
      )
    )
  )
}

export default TaskFooterTeamAssigneeMenuRoot
